// extracted by mini-css-extract-plugin
export default {"icon":"EmployeeWorkingHoursToggle--icon--056e09","toggleButton":"EmployeeWorkingHoursToggle--toggleButton--de10ce","container":"EmployeeWorkingHoursToggle--container--cd62d9"};